module.exports = __webpack_public_path__ + "img/petrifactionImg1.48ad324e.jpg";